import { AxiosResponse } from 'axios';
import { OperationAttainment, OperationType } from 'types/interfaces';

import IApiCalls from 'components/api/interfaces/apiCalls';

import { api } from '../../http';

import BaseService from './BaseService';
import { ApiResponse } from './interfaces';
import IOperationTypesService from './interfaces/OperationTypesService';

class OperationTypesService
  extends BaseService<OperationType>
  implements IOperationTypesService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'OperationTypes');
  }

  getExcelTemplate(): Promise<AxiosResponse<Blob>> {
    return api.get('operationType/getExcelTemplate', {
      responseType: 'blob'
    });
  }

  validate(
    formData: FormData
  ): Promise<
    AxiosResponse<{ operationTypes: OperationType[]; errors: string[] }>
  > {
    return api.post<{ operationTypes: OperationType[]; errors: string[] }>(
      'operationType/validateImport',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
  }

  put(
    formData: FormData
  ): Promise<
    AxiosResponse<{ operationTypes: OperationType[]; errors: string[] }>
  > {
    return api.post<{ operationTypes: OperationType[]; errors: string[] }>(
      'operationType/import',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
  }

  getOperationAttainments(operationTypeIds: number[]): Promise<AxiosResponse<ApiResponse<OperationAttainment[]>>> {
    return api.get('operationType/attainment', {
      params: {
        'operationTypeIds[]': operationTypeIds
      },
      paramsSerializer: {
        indexes: null 
      }
    });
  }

  getOperationPersonsAttainments(
    operationTypeId: number,
    personIds: Array<number | string>
  ): Promise<AxiosResponse<any>> {
    return api.get('operationType/attainment', {
      params: {
        operationTypeId,
        personIds
      },
      paramsSerializer: {
        indexes: null
      }
    });
  }
}

export default OperationTypesService;